module.exports = __webpack_public_path__ + "static/media/nick-karvounis-72018-unsplash.c452b032.jpg";